import { render } from "./CharacterDetails.vue?vue&type=template&id=4343b23c&scoped=true"
import script from "./CharacterDetails.vue?vue&type=script&lang=js"
export * from "./CharacterDetails.vue?vue&type=script&lang=js"

import "./CharacterDetails.vue?vue&type=style&index=0&id=4343b23c&scoped=true&lang=scss"

import exportComponent from "/Users/vklosovych/Desktop/vue-exam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4343b23c"]])

export default __exports__